import { Injectable } from '@angular/core';
import { Headers, Http } from '@angular/http';
import { Credentials} from "./bean";
import { AuthToken} from "./bean";

@Injectable()
export class AuthService {
	constructor(private http: Http) {
		this.isAuthenticated();
		// this.authenticated = JSON.parse(localStorage.getItem('authenticated'));
		// if(this.authenticated == null){
		// 	this.authenticated = false;
		// }
		//this.requestToken();
	}
	public apipath :string = '';
	logout() : void {
		//do real logout.
		this.http.get(this.apipath + '/rest/photo/logout')
		//.toPromise()
		.map(res => res)
		
		//.map()
		.toPromise()
		.then(() => {

		})
		//.catch(this.handleError)
		//.subscribe(people => this.people = people)
//		.subscribe()
		;
		this.authenticated = false;
		localStorage.setItem('authenticated', JSON.stringify(this.authenticated));
	}

	login(credentials:Credentials):Promise<AuthToken>{
		let httpBasicHeaders = new Headers();
		httpBasicHeaders.append('Authorization',
			"Basic " + btoa(credentials.username + ":"
					+ credentials.password)
		);
		httpBasicHeaders.append('X-Requested-With','XMLHttpRequest');
		return this.http.get(this.apipath + "/rest/photo/user"
			,{headers : httpBasicHeaders}
		).toPromise()
		.then((response) => {
			if(response.text() == ''){
				return null;
			}
			this.authenticated = true;
			localStorage.setItem('authenticated', JSON.stringify(this.authenticated));
			return response.json() as AuthToken;
		})
//		.then(response => response.json().data as Map<String,Object>)
		.catch((error: any): Promise<AuthToken> => {
//			console.log('login failed');
			return null;
		})
		;

	}
	private authToken: AuthToken;
	authenticated: boolean = false;
	public async isAuthenticated(){

		const response = await Promise.all([
			// .toPromise()
			// .then(function(response){
			// 	console.log('response');
			// 	console.log(response.json());
			// 	return response.json() as AuthToken;
			// })
			// .catch((error: any): Promise<AuthToken> => {
			// 	console.log('is auth ggggg get authtoken failed');
			// 	console.log(error);
			// 	return null;
			// })
			// ,
			this.requestToken()
		]);
		//console.log('is auth response[0]');
		//console.log(response[0]);
		if(response[0] != null){
			this.authenticated = true;
			localStorage.setItem('authenticated', JSON.stringify(this.authenticated));
			return true;
		}
		this.authenticated = false;
		localStorage.setItem('authenticated', JSON.stringify(this.authenticated));
		return false;
	}
	private async requestToken():Promise<AuthToken>{
		// console.log('this.apiBase');
		// console.log(this.apiBase);
		return this.http.get(this.apipath + "/rest/photo/getAuthToken")
		.toPromise()
		.then(function(response){
//			console.log('request token response');
//			console.log(response);
			return response.json() as AuthToken;
		})
		.catch((error: any): Promise<AuthToken> => {
			// console.log('xxxx get authtoken failed');
			// console.log(error);
			return null;
		})
//		.catch(this.handleError)
		;

	}
	private handleError(error: any): Promise<any> {
		return Promise.reject(error.message || error);
	}
}
//async function isAuthencated():Promise<boolean>{



// WEBPACK FOOTER //
// ./src/app/service.auth.ts